import { Avatar } from '../../../../Avatar'
import { Skeleton } from '../../../../Skeleton'
import { getEmailProfileSkeletonClassName } from '../../../EmailProfile'

import * as styles from './EmailProfileMessageHeaderSkeleton.module.css'

function EmailProfileMessageHeaderSkeleton() {
  return (
    <div className={styles.EmailProfileMessageHeaderSkeleton}>
      <Avatar isLoading className={styles.avatar} />

      <div className={styles.header}>
        <div className={styles.info}>
          <Skeleton className={getEmailProfileSkeletonClassName(styles.name)} />
          <Skeleton className={getEmailProfileSkeletonClassName(styles.to)} />
        </div>

        <div className={styles.actionsContainer}>
          <Skeleton className={getEmailProfileSkeletonClassName(styles.date)} />

          <div className={styles.actions}>
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                className={getEmailProfileSkeletonClassName(styles.action)}
                key={index}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmailProfileMessageHeaderSkeleton
